"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkRestConnectivity = exports.checkRPCConnectivity = exports.DifferentChainVersionError = void 0;
const axios_1 = __importDefault(require("axios"));
const cosmos_1 = require("@keplr-wallet/cosmos");
class DifferentChainVersionError extends Error {
    constructor(m) {
        super(m);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, DifferentChainVersionError.prototype);
    }
}
exports.DifferentChainVersionError = DifferentChainVersionError;
function checkRPCConnectivity(chainId, rpc, wsObject) {
    return __awaiter(this, void 0, void 0, function* () {
        const rpcInstance = axios_1.default.create({
            baseURL: rpc,
        });
        let resultStatus;
        try {
            // Get the status to get the chain id.
            resultStatus = yield rpcInstance.get("/status");
        }
        catch (e) {
            console.log(e);
            throw new Error("Failed to get response /status from rpc endpoint");
        }
        const version = cosmos_1.ChainIdHelper.parse(chainId);
        const versionFromRPCStatus = cosmos_1.ChainIdHelper.parse(resultStatus.data.result.node_info.network);
        if (versionFromRPCStatus.identifier !== version.identifier) {
            throw new Error(`RPC endpoint has different chain id (expected: ${chainId}, actual: ${resultStatus.data.result.node_info.network})`);
        }
        else if (versionFromRPCStatus.version !== version.version) {
            // In the form of {chain_identifier}-{chain_version}, if the identifier is the same but the version is different, it is strictly an error,
            // but it is actually the same chain but the chain version of the node is different.
            // In this case, it is possible to treat as a warning and proceed as it is, so this is separated with above error.
            throw new DifferentChainVersionError(`RPC endpoint has different chain id (expected: ${chainId}, actual: ${resultStatus.data.result.node_info.network})`);
        }
        let wsURL = rpc;
        if (wsURL.startsWith("http")) {
            wsURL = wsURL.replace("http", "ws");
        }
        wsURL = wsURL.endsWith("/") ? wsURL + "websocket" : wsURL + "/websocket";
        const wsInstance = wsObject ? wsObject(wsURL) : new WebSocket(wsURL);
        wsInstance.onerror = () => {
            // To prevent not catchable error,
            // provide noop handler.
        };
        let wsConnected = false;
        // Try 15 times at 1 second intervals to test websocket connectivity.
        for (let i = 0; i < 15; i++) {
            // If ws state is not "connecting"
            if (wsInstance.readyState !== 0) {
                // If ws state is "open", it means that app can connect ws to /websocket rpc
                if (wsInstance.readyState === 1) {
                    wsConnected = true;
                    break;
                }
                else {
                    // else, handle that as error.
                    throw new Error("Failed to connect websocket to /websocket rpc");
                }
            }
            yield new Promise((resolve) => setTimeout(resolve, 1000));
        }
        // Close web socket
        wsInstance.close();
        if (!wsConnected) {
            throw new Error("Failed to connect websocket to /websocket rpc");
        }
    });
}
exports.checkRPCConnectivity = checkRPCConnectivity;
function checkRestConnectivity(chainId, rest) {
    return __awaiter(this, void 0, void 0, function* () {
        const restInstance = axios_1.default.create({
            baseURL: rest,
        });
        let resultLCDNodeInfo;
        try {
            // Get the node info to get the chain id.
            resultLCDNodeInfo = yield restInstance.get("/cosmos/base/tendermint/v1beta1/node_info");
        }
        catch (e) {
            console.log(e);
            throw new Error("Failed to get response /cosmos/base/tendermint/v1beta1/node_info from lcd endpoint");
        }
        const version = cosmos_1.ChainIdHelper.parse(chainId);
        const versionFromLCDNodeInfo = cosmos_1.ChainIdHelper.parse(resultLCDNodeInfo.data.default_node_info.network);
        if (versionFromLCDNodeInfo.identifier !== version.identifier) {
            throw new Error(`LCD endpoint has different chain id (expected: ${chainId}, actual: ${resultLCDNodeInfo.data.default_node_info.network})`);
        }
        else if (versionFromLCDNodeInfo.version !== version.version) {
            // In the form of {chain_identifier}-{chain_version}, if the identifier is the same but the version is different, it is strictly an error,
            // but it is actually the same chain but the chain version of the node is different.
            // In this case, it is possible to treat as a warning and proceed as it is, so this is separated with above error.
            throw new DifferentChainVersionError(`LCD endpoint has different chain id (expected: ${chainId}, actual: ${resultLCDNodeInfo.data.default_node_info.network})`);
        }
    });
}
exports.checkRestConnectivity = checkRestConnectivity;
//# sourceMappingURL=connection.js.map